import React from 'react';
import SharedItemCells from './SharedItemCells';
import IItemProps from './IItemProps';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import { ISalesTaxViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

export const SalesTax: React.FC<
  IItemProps & IHasItemDataProps<ISalesTaxViewItem> & Required<IHasItemEventProps<ISalesTaxViewItem>>
> = (props) => {
  return (
    <div data-test-id={`Sales-Tax-${props.data.id}`}>
      <SharedItemCells
        {...props}
        readOnly={!!props.data.parent_id || !props.hasEditPermissions}
        showRemove={!props.data.parent_id}
        nettedOutDisplay={props.data.parent_id ? 'none' : 'input'}
      >
        Sales Tax{props.data.parent_id ? ` (for the above item)` : ''}
      </SharedItemCells>
    </div>
  );
};
